import _ from 'lodash';
import util from '../util';
if (!window.promokitStore) {
  window.promokitStore = {
    isPreload: false,
    staticPath: util.getStaticPath(util.getNetwork()),
    network: util.getNetwork(),
    os: util.getOs(),
    browser: util.getBrowser(),
    isMobile: util.isMobile(),
    isMobileGame: util.isMobileGame(),
    device: util.getDevice(),
    game: util.getGame(),
    vendorPrefix: util.vendorPrefix(),
    userData: {},
    sequence: {},
    youtube: {},
    video: {},
    layerStack: [],
    nowSelect: null,
    player: [],
    isFullscreenVideo: false,
    isIpad: util.isIpad(),
    isIphone: util.isIphone(),
    nowPlayingList: [],
    preloadLength: {
      sequence: 0,
      youtube: 0,
      video: 0,
      image: 0
    }
  };
}

const store = (key, value) => {
  if (value !== undefined) {
    window.promokitStore = _.set(window.promokitStore, key, value);

    return _.get(window.promokitStore, key);
  }
  else {
    if (_.has(window.promokitStore, key)) {
      return _.get(window.promokitStore, key);
    }
    else {
      return undefined;
    }
  }

};

export default store;
